import { IconType, GenIcon } from "react-icons/lib/esm/iconBase";

export const PlayIcon: IconType = GenIcon({
  tag: "svg",
  attr: { viewBox: "0 0 512 512" },
  child: [
    {
      tag: "path",
      attr: {
        d: "M96 52v408l320-204L96 52z",
      },
      child: [],
    },
  ],
});
